/*eslint-disable react/jsx-key */
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
//import './index.scss';
import { useNavigate } from 'react-router-dom';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';
import { ApprovalIcons } from '../../../img/GlobalSVG';
import noDelete from '../../../img/pricecompare/no-delete.svg';
import GenericButton from 'src/Components/GenericButton/GenericButton';
//import './SelfRegistrationListTable.scss';
import CommonApproveDeniedAPI from './CommonApproveDeniedAPI';
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const SelfRegistrationTable = ({
  columns,
  data,
  pageSizeCount,
  dataFetching,
  labelProp = 'My Claims',
  //customSortingHandler,
  sortByColumn,
  //serverSideSorting,
  documentDataList,
  currentPage,
  tabName,
  searchTerm,
  requestTypeName,
  serverSideSorting,
}) => {
  const { approveProviderData, deniedProviderData } = CommonApproveDeniedAPI();
  console.log(data, 'data before display');
  const navigate = useNavigate();
  //Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    setPageSize,
    pageCount,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: pageSizeCount,
        sortBy: ['id'],
      },
      manualSortBy: true,
      defaultColumn: {
        size: 100,
      },
    },
    useSortBy,
    usePagination,
  );

  console.log(headerGroups, data, 'headerGroups');

  useEffect(() => {
    //customSortingHandler(sortBy[0]?.id, sortBy[0]?.desc, sortBy);
    serverSideSorting(
      sortBy[0]?.id,
      sortBy[0]?.desc === true ? 'desc' : 'asc',
      sortBy,
    );
  }, [sortBy]);

  //const onClick = (ele) => {
  //if (ele) {
  //console.log(ele, 'PageRedirect');
  //navigate(`/admin/claim-details?trx=${ele}`, {
  //state: {
  //tab: tabName,
  //requestType: requestTypeName,
  //searchTerm: searchTerm,
  //pageSize: pageSizeCount,
  //pageNumber: currentPage,
  //},
  //});
  //}
  //};
  useMemo(() => {
    setPageSize(pageSizeCount);
  }, [pageSizeCount]);
  //Render the UI for your table

  const [hoverRowIdentify, setHoverRowIdentify] = useState('');

  const handleRowHover = (row) => {
    console.log('Row', row);
    setHoverRowIdentify(row?.original?.oid);
  };

  const dataRenderHandler = (index, value, row, cellvalue) => {
    if (index === 4) {
      if (cellvalue === 'Pending Approval') {
        return (
          <div className="d-flex justify-content-center">
            <span>
              <ApprovalIcons.PendingSVG />
            </span>
          </div>
        );
      } else if (cellvalue === 'Approved') {
        return (
          <div className="d-flex justify-content-center">
            <span>
              <ApprovalIcons.ApprovedSVG />
            </span>
          </div>
        );
      } else {
        return (
          <div className="d-flex justify-content-center">
            <span>
              <ApprovalIcons.DeniedSVG />
            </span>
          </div>
        );
      }
    } else if (index === 5 && row?.original?.status === 'Pending Approval') {
      return hoverRowIdentify === row?.original?.oid ? (
        <div className="d-flex pl-4">
          <div className="pl-3 pr-3">
            {/*<GenericButton
              variant="secondary"
              onClick={() => {
                //setIsComposing(true);
                //setReplyEnabled(false);
                console.log('confirm ');
              }}
              className="pl-3 pr-3"
            >
              <span>
                <ApprovalIcons.ApprovedRightSVG />
              </span>
              APPROVE
            </GenericButton> */}
            <span
              onClick={() =>
                approveProviderData(
                  row?.original?.oid,
                  row?.original?.tempuseroid,
                  () => {
                    documentDataList();
                  },
                  null,
                  row?.original?.name,
                )
              }
            >
              <ApprovalIcons.ApprovedRightSVG />
            </span>
          </div>
          <div className="pl-3 pr-3">
            <span
              onClick={() =>
                deniedProviderData(
                  row?.original?.oid,
                  row?.original?.tempuseroid,
                  () => {
                    documentDataList();
                  },
                  null,
                  row?.original?.name,
                )
              }
            >
              <ApprovalIcons.DeniedWrongSVG />
            </span>
          </div>
        </div>
      ) : (
        value
      );
    } else {
      return value;
    }
  };
  return (
    <div className="provider-self-registration-table">
      <table className="table padding-mobile-0" {...getTableProps()}>
        {data?.length > 0 && !dataFetching && (
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(
                      column.getSortByToggleProps({ title: undefined }),
                    )}
                    style={{
                      width: column.width,
                      maxWidth: column.maxWidth,
                      minWidth: column.minWidth,
                      cursor: 'pointer',
                    }}
                    className={
                      column.isSorted ? 'coloumnIsSorted' : 'coloumnNotSorted'
                    }
                  >
                    <b>{column.render('Header')}</b>
                    {(column.render('Header') === 'Status' ||
                      column.render('Header') === 'Submitted On') && (
                      <span
                        className={
                          column.isSorted
                            ? column.isSortedDesc
                              ? 'arrowDown'
                              : 'arrowUp'
                            : 'arrowNormal'
                        }
                      ></span>
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
        )}

        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className="active-column-self-provider"
              >
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      //onClick={() => onClick(row.original.ClaimOid)}
                      className="pt-3"
                      onMouseOver={() =>
                        index === 5 ? handleRowHover(row) : ''
                      }
                      onMouseLeave={() =>
                        index === 5 ? setHoverRowIdentify('') : ''
                      }
                    >
                      <div className="request-data">
                        {dataRenderHandler(
                          index,
                          cell.render('Cell'),
                          row,
                          cell.value,
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {/*{data?.length === 0 && !dataFetching && (
        <div className="claims-no-data text-center">
          <CustomClientError
            CustomClasses="p-0 m-0"
            ErrorHeading="No Claims found!"
            ErrorMessage="We could not find any Claims for the selected filter(s).
            Use another filter(s) and try again."
          />
        </div>
      )} */}
    </div>
  );
};

export default SelfRegistrationTable;
